import { SubmitPolicyholderDataClientRequest } from '../../../@types/SubmitPolicyholderData'
import { usePolicyholderDetailsStore } from '../../../Stores/policyholderDetailsStore'
import { useSimulatorStore } from '../../../Stores/simulatorStore'
import { useCreateProposalStore } from '../../../Stores/useCreateProposalStore'

export const useSubmitPolicyHolderDataPayload = () => {
  const { createProposal } = useCreateProposalStore()
  const {
    policyholderDetailsSelected,
    phoneSelected,
    policyholderAddressSelected,
  } = usePolicyholderDetailsStore()
  const { entity, entitySelectedAddress } = useSimulatorStore()

  const addressSelected = policyholderDetailsSelected?.addresses?.filter(
    (item) =>
      item.locationId ===
      (policyholderAddressSelected?.locationId ||
        entitySelectedAddress?.sequence ||
        ''),
  )

  const useSubmitPolicyHolderDataPayload: SubmitPolicyholderDataClientRequest =
    {
      policyholder: {
        addresses: addressSelected?.map((item) => ({
          mailingAddressId: item.locationId,
          addressId: item.locationId,
          zipCode: item.postalCode?.split('-')[0] || '',
          zipCodeExtension: item.postalCode?.split('-')[1] || '',
        })),
        contacts: [
          {
            phoneContactDetails: [
              {
                phoneContactId:
                  policyholderDetailsSelected?.phoneContactsList?.find(
                    (item) => item.contactNumber === phoneSelected,
                  )?.contactId || '',
              },
            ],
          },
        ],
        birthDate: policyholderDetailsSelected?.birthdate,
        endDate: entity.endDate,
        entityId: policyholderDetailsSelected?.idEntity,
        initialDate: entity.initialDate,
        payer: entity.payer,
        paymentPercent: 0,
      },
      proposalId: createProposal?.createProposalResponse?.proposalId || '',
    }

  return useSubmitPolicyHolderDataPayload
}
